import { CypherKey, CypherToken } from '@app/constants/params';

const CRC_TABLE = Array(256);

const getCRC32 = (text: string) => {
  for (let i = 0; i < 256; ++i) {
    let code = i;
    for (let j = 0; j < 8; ++j) {
      code = (code & 0x01 ? 0xEDB88320 ^ (code >>> 1) : (code >>> 1));
    }
    CRC_TABLE[i] = code;
  }

  let crc = -1;
  for (let i = 0; i < text.length; ++i) {
    const code = text.charCodeAt(i);
    crc = CRC_TABLE[(code ^ crc) & 0xFF] ^ (crc >>> 8);
  }
  return (-1 ^ crc) >>> 0;
}

const ID = (_length = 5) => Math.random().toString(36).substring(2, _length);

const ALPHA = '0123456789+/ABCDEFGHIJKLMNOPQRSTUVWXYZ-._abcdefghijklmnopqrstuvwxyz=';

export const CK = () => `${getCRC32(ID(8))}.${getCRC32(ID(8))}.${getCRC32(ID(8))}.${getCRC32(ID(8))}`;

export function encrypt(text: string, ck: string): { encrypted: string, ck: string } {
  const base64 = btoa(text);
  const arr = base64.split('');
  const arrCk = ck.split('');

  let lastLetter = 0;
  let encrypted = '';

  for (let i = 0; i < arr.length; i++) {
    const letter = arr[i];
    const _letter = arrCk[lastLetter];
    const temp = getLetterFromAlphabetForLetter(_letter, letter);

    if (temp) {
      encrypted += temp;
    } else {
      return null;
    }
    if (lastLetter == (arrCk.length - 1)) {
      lastLetter = 0;
    } else {
      lastLetter++;
    }
  }

  return { encrypted: encodeURIComponent(encrypted), ck };
}

export function decrypt(text: string, ck: string): string {
  const arr = decodeURIComponent(text).split('');
  const arrCk = ck.split('');

  let lastPassLetter = 0;
  let decrypted = '';

  for (let i = 0; i < arr.length; i++) {
    const letter = arr[i];
    const passwordLetter = arrCk[lastPassLetter];
    const temp = getInvertedLetterFromAlphabetForLetter(passwordLetter, letter);

    if (temp) {
      decrypted += temp;
    } else {
      return null;
    }
    if (lastPassLetter == (arrCk.length - 1)) {
      lastPassLetter = 0;
    } else {
      lastPassLetter++;
    }
  }

  return atob(decrypted);
}

export function getCtParams(_encrypt: string): string {
  return _encrypt.split('.').map((el) => `${CypherToken}_${ID()}=${el}`).join('&');
}

export function getCkParams(el: string): string {
  return `${CypherKey}_${ID()}=${el}`;
}

export function getTokenParams(params: Object): string {
  const ctParams = Object.keys(params)
    .filter((_key) => _key.startsWith(`${CypherToken}_`))
    .reduce((obj, _key) => {
      obj[_key] = params[_key];
      return obj;
    }, {});
  return Object.values(ctParams).join('.');
}

export function getKeyParams(params: Object): string {
  const ctParams = Object.keys(params)
    .filter((_key) => _key.startsWith(`${CypherKey}_`))
    .reduce((obj, _key) => {
      obj[_key] = params[_key];
      return obj;
    }, {});
  return Object.values(ctParams).join('.');
}

export function getAllowedParams(params: Object): string {
  const _params = Object.keys(params)
    .filter((_key) => !_key.startsWith(`${CypherToken}_`) && !_key.startsWith(`${CypherKey}_`))
    .reduce((obj, _key) => {
      obj[_key] = params[_key];
      return obj;
    }, {});
  return new URLSearchParams(_params).toString();
}

function getLetterFromAlphabetForLetter(letter: string, letterToChange: string): string {
  const posLetter = ALPHA.indexOf(letter);

  if (posLetter == -1) {
    return null;
  }

  const postChange = ALPHA.indexOf(letterToChange);

  if (postChange == -1) {
    return null;
  }

  const part1 = ALPHA.substring(posLetter, ALPHA.length);
  const part2 = ALPHA.substring(0, posLetter);
  const newText = `${part1}${part2}`;

  return newText.split('')[postChange];
}

function getInvertedLetterFromAlphabetForLetter(letter: string, letterToChange: string) {
  const posLetter = ALPHA.indexOf(letter);

  if (posLetter == -1) {
    return null;
  }
  const part1 = ALPHA.substring(posLetter, ALPHA.length);
  const part2 = ALPHA.substring(0, posLetter);

  const newText = `${part1}${part2}`;

  const postChange = newText.indexOf(letterToChange);

  if (postChange == -1) {
    return null;
  }

  return ALPHA.split('')[postChange];
}
